import { Component, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';

import { Global } from '../../../../../app.global';
import { Constants } from '../../../helper/constants';

import { BusLaneCopy } from '../../../helper/textcopy/policies.text';
import { RadioQuestionModel } from '../../../viewmodels/policy-item.model';
import { GlobalObservables } from '../../../../../app.global.observer';
import { Subscription } from 'rxjs';
import { HelperService } from '../../../services/helper.service';
import { KeyDescriptionViewModel } from '../../../viewmodels/keyDescriptionViewModel';
import { AdminService } from '../../../../../layouts/services/admin.service';
import { BusLaneModel } from '../../../../../layouts/viewmodels/bus-lane.model';
// import { ValueTransformer } from '@angular/compiler/src/util';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'bus-lane-policy',
  templateUrl: './bus-lane.component.html',
})
export class BusLaneComponent implements OnInit, OnDestroy {
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onSavePolicies = new EventEmitter();
  textCopy = BusLaneCopy;
  constants = Constants;
  policiesAnswersSetted = new Subscription();
  policiesAnswers: any = this.global.policiesAnswers;
  busLaneSuccess = false;
  busLaneMessage = '';

  firstRadioQuestions: Array<{
    id: number;
    data: any;
    active: boolean;
    valueSelected: any;
  }>;
  thirdRadioQuestion: RadioQuestionModel;
  fourthRadioQuestion: RadioQuestionModel;
  busLaneList: Array<BusLaneModel> = [];
  selectedBusLane = new BusLaneModel();
  busLaneCancel = '';
  busLaneNotice = '';
  busLaneDescriptionMaxLength = 2500;

  constructor(
    public global: Global,
    private globalObs: GlobalObservables,
    private helpServ: HelperService,
    private adminService: AdminService
  ) {}

  ngOnInit() {
    this.setFirstRadioQuestions();
    this.setBusLaneList();
    this.setThirdRadioQuestion();
    this.setFourthRadioQuestion();

    if (this.helpServ.isEmpty(this.policiesAnswers)) {
      this.onPoliciesAnswersSetted();
    } else {
      this.setSelectedValues();
    }
  }

  setFirstRadioQuestions() {
    const defaultAnswers = [
      {
        text: 'yes',
        value: 'y',
      },
      {
        text: 'no',
        value: 'n',
      },
      {
        text: 'it depends (eg on which street they were in) so ask the user',
        value: 'd',
      },
    ];
    this.firstRadioQuestions = [
      {
        id: 1,
        data: {
          title: 'Cash in transit?',
          includeTitle: false,
          beforeText: '',
          afterText: '',
          answers: defaultAnswers,
        },
        active: true,
        valueSelected: 'y',
      },
      {
        id: 2,
        data: {
          title:
            'Patient being taken to or from a hospital or medical / care centre (eg medicar service)?',
          includeTitle: false,
          beforeText: '',
          afterText: '',
          answers: defaultAnswers,
        },
        active: true,
        valueSelected: 'n',
      },
      {
        id: 3,
        data: {
          title: 'Private-hire vehicle?',
          includeTitle: false,
          beforeText: '',
          afterText: '',
          answers: defaultAnswers,
        },
        active: true,
        valueSelected: 'n',
      },
      {
        id: 4,
        data: {
          title: 'Vehicle involved in a statutory undertaking?',
          includeTitle: false,
          beforeText: '',
          afterText: '',
          answers: defaultAnswers,
        },
        active: true,
        valueSelected: 'y',
      },
      {
        id: 5,
        data: {
          title: 'Police vehicle in covert pursuit or blue-light situation?',
          includeTitle: false,
          beforeText: '',
          afterText: '',
          answers: defaultAnswers,
        },
        active: true,
        valueSelected: 'y',
      },
    ];
  }

  onFirstRadioQuestionsSelect(answerValue, questionId) {
    this.firstRadioQuestions[questionId - 1].valueSelected = answerValue;
  }

  setThirdRadioQuestion() {
    this.thirdRadioQuestion = {
      data: {
        title: "Are your bus lane notices called something other than 'Penalty Charge Notices'?",
        includeTitle: true,
        beforeText: '',
        afterText: '',
        answers: [
          {
            text: 'yes',
            value: 'y',
          },
          {
            text: 'no',
            value: 'n',
          },
        ],
      },
      active: true,
      valueSelected: 'n',
    };
  }

  onThirdRadioQuestionSelect(answerValue) {
    this.thirdRadioQuestion.valueSelected = answerValue;
  }

  setFourthRadioQuestion() {
    this.fourthRadioQuestion = {
      data: {
        title:
          'Do you transfer liability for bus lane PCNs if the hire agreement is for less than 6 months?',
        includeTitle: true,
        beforeText: '',
        afterText: '',
        answers: [
          {
            text: 'yes',
            value: 'y',
          },
          {
            text: 'no',
            value: 'n',
          },
        ],
      },
      active: true,
      valueSelected: 'y',
    };
  }

  onFourthRadioQuestionSelect(answerValue) {
    this.fourthRadioQuestion.valueSelected = answerValue;
  }

  setBusLaneList() {
    this.adminService.getBusLanes().subscribe(
      (busLanes) => {
        if (busLanes) {
          this.busLaneList = busLanes;
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  onBusLaneSelectionChange(value) {
    this.busLaneMessage = '';
    if (value === '1') {
      this.selectedBusLane = {
        id: '1',
        name: '',
        description: '',
        selectedTypeId: '1',
        location: '',
      };
      return;
    }
    this.busLaneList.forEach((busLane) => {
      if (busLane.id.toString() === value) {
        this.selectedBusLane = busLane;
      }
    });
  }

  deleteBusLane() {
    if (!this.isBusLaneSelected()) {
      return;
    }
    this.busLaneMessage = '';
    this.adminService.deleteBusLane(parseInt(this.selectedBusLane.id, 10)).subscribe(
      (result) => {
        this.busLaneSuccess = result.success;
        this.busLaneMessage = result.message;
        this.removeBusLaneFromList();
      },
      (error) => {
        this.busLaneSuccess = false;
        this.busLaneMessage = 'Something went wrong. Please try again.';
      }
    );
  }

  removeBusLaneFromList() {
    const busLanesIds = [];
    this.busLaneList.forEach((busLane) => {
      busLanesIds.push(busLane.id);
    });
    const selectedBusLaneIndex = busLanesIds.indexOf(this.selectedBusLane.id);
    if (selectedBusLaneIndex > -1) {
      this.busLaneList.splice(selectedBusLaneIndex, 1);
      this.busLaneList = this.busLaneList.slice();
    }
    console.log(this.busLaneList);
  }

  isBusLaneSelected() {
    return this.selectedBusLane.id !== '0' && this.selectedBusLane.id !== '1';
  }

  isBusLaneDisabled() {
    return this.selectedBusLane.id === '0';
  }

  addBusLane() {
    if (this.selectedBusLane.id !== '1') {
      return;
    }
    this.busLaneMessage = '';
    this.adminService.addBusLane(this.selectedBusLane).subscribe(
      (result) => {
        this.busLaneSuccess = result.success;
        this.busLaneMessage = result.message;
        this.selectedBusLane.id = '000' + this.busLaneList.length.toString();
        this.busLaneList.push(this.selectedBusLane);
      },
      (error) => {
        this.busLaneSuccess = false;
        this.busLaneMessage = 'Something went wrong. Please try again.';
      }
    );
  }

  updateBusLane() {
    if (this.selectedBusLane.id === '1') {
      return;
    }
    this.busLaneMessage = '';
    this.adminService.updateBusLane(this.selectedBusLane).subscribe(
      (result) => {
        this.busLaneSuccess = result.success;
        this.busLaneMessage = result.message;
      },
      (error) => {
        this.busLaneSuccess = false;
        this.busLaneMessage = 'Something went wrong. Please try again.';
      }
    );
  }

  setSelectedValues() {
    this.policiesAnswers = this.global.policiesAnswers;

    this.setSelectedFirstRadioQuestions();
    this.thirdRadioQuestion.valueSelected = this.policiesAnswers['29_3_1'];
    this.fourthRadioQuestion.valueSelected = this.policiesAnswers['29_4_1'];
    this.busLaneCancel = this.policiesAnswers['29_3_2'];
    this.busLaneNotice = this.policiesAnswers['29_3_3'];
  }

  setSelectedFirstRadioQuestions() {
    const selectedAnswers = [
      { id: 1, value: this.policiesAnswers['29_1_1'] },
      { id: 2, value: this.policiesAnswers['29_1_2'] },
      { id: 3, value: this.policiesAnswers['29_1_3'] },
      { id: 4, value: this.policiesAnswers['29_1_4'] },
      { id: 5, value: this.policiesAnswers['29_1_5'] },
    ];
    this.firstRadioQuestions.forEach((question) => {
      selectedAnswers.forEach((selectedAnswer) => {
        if (question.id === selectedAnswer.id) {
          question.valueSelected = selectedAnswer.value;
        }
      });
    });
  }

  onPoliciesAnswersSetted() {
    this.policiesAnswers = this.global.policiesAnswers;
    this.policiesAnswersSetted = this.globalObs.onPoliciesAnswersSetted.subscribe(() => {
      this.setSelectedValues();
    });
  }

  submitPolicyCategory() {
    let policyList = new Array<KeyDescriptionViewModel>();
    policyList = [
      { id: '29_3_1', description: this.thirdRadioQuestion.valueSelected },
      { id: '29_3_2', description: this.busLaneCancel },
      { id: '29_3_3', description: this.busLaneNotice },
      { id: '29_4_1', description: this.fourthRadioQuestion.valueSelected },
    ];
    this.firstRadioQuestions.forEach((question, index) => {
      policyList.push({ id: `29_1_${index + 1}`, description: question.valueSelected });
    });

    this.onSavePolicies.emit(policyList);
  }

  ngOnDestroy() {
    if (this.helpServ.isEmpty(this.policiesAnswers)) {
      this.policiesAnswersSetted.unsubscribe();
    }
  }
}
